import * as AppConstants from 'app/AppConstants';
import {fetchLayoutFrameStyles} from './layoutFrameService';
import {loadFeatures} from 'state/feature/featureActions';

export const loadLayoutFrameStyles = frameId => dispatch => {
  if (!frameId) return;
  dispatch(loadFeatures()).then(() => {
    const version = 'v4';
    fetchLayoutFrameStyles(frameId, version).then(response => {
      dispatch({
        type: AppConstants.LAYOUT_FRAME__LOAD_FINISHED,
        payload: {
          frameId,
          styles: response,
        },
      });
    });
  });
};
